import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const UnProtectedRoute = ({ component }) => {
  const [hasAccess, setHasAccess] = useState(false);
  const navigate = useNavigate();
  const { processId } = useParams(); // Get processId from URL

  useEffect(() => {
    const accessToken = localStorage.getItem("access_token");
    setHasAccess(accessToken ? true : false);
    if (accessToken) {
      // If processId exists, redirect to paywall with processId
      if (processId) {
        navigate(`/learn/paywall/${processId}`);
      } else {
        navigate("/learn");
      }
    }
  }, [component, processId, navigate]);

  return !hasAccess ? (
    <React.Fragment>{component}</React.Fragment>
  ) : (
    <React.Fragment />
  );
};

export default UnProtectedRoute;